module.exports = __webpack_public_path__ + "img/ib.d84c9782.png";